import { GrowthBookProvider } from "@growthbook/growthbook-react";
import React, { ReactNode, useEffect } from "react";

import { getVersionAndPlatformData } from "../../modules/platformUtils";
import { CurrentUser } from "../../redux_store/auth/models";
import { UserProfile } from "../../redux_store/user/models";
import { gb } from "../../utils/growthbook";

interface FeatureFlagProps {
  children: ReactNode;
  user?: CurrentUser;
  profile?: UserProfile | null;
  sessionId?: string;
}

const FeatureFlag: React.FC<FeatureFlagProps> = ({
  children,
  sessionId,
  user,
  profile,
}) => {
  useEffect(() => {
    // Load features from the GrowthBook API
    gb.loadFeatures({ autoRefresh: true });
  }, []);

  useEffect(() => {
    if (user && profile) {
      // update to track user specific attributes when available
      gb.setAttributes({
        ...gb.getAttributes(),
        id: profile.id,
        brazeId: user.brazeId,
        firstName: user.firstName,
        lastName: user.lastName,
        registrationComplete: user.registrationComplete,
        verifiedEmail: user.verifiedEmail,
        verifiedMobileNumber: user.verifiedMobileNumber,
      });
    } else {
      const versionPlatform = getVersionAndPlatformData();
      // track app/platform and session ID as bare minimum
      gb.setAttributes({
        appVersion: versionPlatform.clientVersion,
        platformType: versionPlatform.clientPlatformType,
        sessionId,
      });
    }
  }, [profile, sessionId, user]);

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};

export default FeatureFlag;
